import React, { useEffect } from "react";
import {
  ContainerReports,
  ContainerIframe,
} from "./YammerTopicContainer.styled";

const YammerTopicContainer = () => {
  const iframe =
    '<iframe name="embed-feed" title="Yammer" src="https://web.yammer.com/embed/topics/eyJfdHlwZSI6IlRvcGljIiwiaWQiOiI2NzQxMzQ0MjU2MCJ9?header=false&footer=false&theme=light" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  // const iframe =
  //   '<iframe name="embed-feed" title="Yammer" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>'

  useEffect(() => {
    // setTimeout(function(){
    //   scriptjs('https://c64.assets-yammer.com/assets/platform_embed.js', function(){
    //   //$('#embed-feed').remove();
    //   window.yam.connect.embedFeed({
    //          container: '#embedded-feed',
    //          network: 'fourleaf.com',
    //          feedType: 'group',                // can be 'group', 'topic', or 'user'
    //          feedId: '78957993984'
    //      });
    //   });
    //   }, 1000);
    //   yam.connect.embedFeed({
    //     container: '#embedded-feed',
    //     network: 'fourleaf.com',
    //     feedType: 'group',                // can be 'group', 'topic', or 'user'
    //     feedId: '78957993984'
    // });
  }, []);

  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default YammerTopicContainer;
